export default function () {
  // noop

  // use this function as a noop syntax sugar that for mobx-values that you are
  // listening to, but not using in any way. passing it to this (or any)
  // function will make mobx listen for changes and the code more verbose

}
